export const findTargetLog = (
	num1: number,
	num2: number,
	axis: number,
	isLong: boolean,
): number => {
	// Convert inputs to log space
	const logAxis = Math.log(axis)
	const logNum1 = Math.log(num1)
	const logNum2 = Math.log(num2)

	// Calculate target in log scale
	const logTarget = isLong
		? logAxis + (logNum1 - logNum2)
		: logAxis - (logNum1 - logNum2)

	// Convert back to price scale and round
	const target = Math.exp(logTarget)

	return Math.round(target * 100) / 100
}
